export default "__VITE_ASSET__4708840e__"